import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { CalculatorListComponent } from './calculators/calculator-list/calculator-list.component';
import { CardModule } from 'primeng/card';
import { TranslocoModule } from '@jsverse/transloco';
import { HolidayCalculatorComponent } from './calculators/holiday-calculator/holiday-calculator.component';
import { CustomCardComponent } from '../shared/custom-card/custom-card.component';
import { CardsListComponent } from '../shared/cards-list/cards-list.component';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { MegaMenuModule } from 'primeng/megamenu';
import { TooltipModule } from 'primeng/tooltip';
import { MenuComponent } from './menu/menu.component';
import { SelectModule } from 'primeng/select';
import { ToastModule } from 'primeng/toast';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { PopoverModule } from 'primeng/popover';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { ChipModule } from 'primeng/chip';
import { RouterLink, RouterOutlet } from '@angular/router';
import { PageHeaderComponent } from '../shared/components/page-header/page-header.component';
import { SidebarComponent } from '../shared/components/sidebar/sidebar.component';
import { MobileToolbarComponent } from '../shared/components/mobile-toolbar/mobile-toolbar.component';
import { OnboardingPopupComponent } from '../shared/components/onboarding-popup/onboarding-popup.component';
import { ContactSalesModalComponent } from '../shared/components/contact-sales-modal/contact-sales-modal.component';
import { DemoCtaComponent } from '../shared/components/demo-cta/demo-cta.component';
import { UpdateNotesModalComponent } from '../update-notes/components/update-notes-modal/update-notes-modal.component';

@NgModule({
  declarations: [
    UserDashboardComponent,
    CalculatorListComponent,
    HolidayCalculatorComponent,
    MenuComponent,
  ],
  imports: [
    SidebarComponent,
    MobileToolbarComponent,
    OnboardingPopupComponent,
    ContactSalesModalComponent,
    UpdateNotesModalComponent,
    ConfirmDialogModule,
    PopoverModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    ToastModule,
    ButtonModule,
    FormsModule,
    ChipModule,
    CommonModule,
    CardModule,
    CustomCardComponent,
    CardsListComponent,
    MegaMenuModule,
    CommonModule,
    TooltipModule,
    TranslocoModule,
    SelectModule,
    FormsModule,
    ButtonModule,
    RouterLink,
    RouterOutlet,
    PageHeaderComponent,
    DemoCtaComponent,
  ],
  providers: [ConfirmationService],
})
export class UserModule {}
